export const IS_DEV =
  (typeof import.meta !== "undefined" && import.meta.env?.DEV === true) ||
  (typeof process !== "undefined" && process.env?.NODE_ENV === "development");

export function debugLog(...args: unknown[]) {
  if (IS_DEV) {
    console.log(...args);
  }
}

export function debugWarn(...args: unknown[]) {
  if (IS_DEV) {
    console.warn(...args);
  }
}

export function debugError(...args: unknown[]) {
  if (IS_DEV) {
    console.error(...args);
  }
}
